import { Box, Container, Typography, Paper } from "@mui/material";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";

import VerifiedIcon from "@mui/icons-material/Verified";

function HeroSection() {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 5,
        mb: 5,
        py: { xs: 6, md: 8 },
        background:
          "linear-gradient(135deg,#F9FFF9 0%,#EFF8F0 50%,#E8F5E9 100%)",
        border: "1px solid #D7EFD9",
        boxShadow: "0 10px 35px rgba(11,60,93,0.08)",

        "&::before": {
          content: '""',
          position: "absolute",
          width: 280,
          height: 280,
          borderRadius: "50%",
          background: "rgba(76,175,80,.08)",
          top: -120,
          left: -120,
        },

        "&::after": {
          content: '""',
          position: "absolute",
          width: 220,
          height: 220,
          borderRadius: "50%",
          background: "rgba(129,199,132,.10)",
          bottom: -80,
          right: -80,
        },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: "center",
            position: "relative",
            zIndex: 2,
          }}
        >
          <LocalFloristIcon
            sx={{
              fontSize: 60,
              color: "#4CAF50",
              mb: 2,
            }}
          />

          <Typography
            sx={{
              fontSize: {
                xs: "2rem",
                sm: "2.8rem",
                md: "3.3rem",
              },
              fontWeight: 800,
              color: "#0B3C5D",
              letterSpacing: 0.5,
            }}
          >
            Rayalaseema University
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: {
                xs: "1.4rem",
                md: "2rem",
              },
              fontWeight: 700,
              color: "#0B3C5D",
            }}
          >
            Digital Flora
          </Typography>
          <Typography
            sx={{
              fontSize: {
                xs: "1rem",
                md: "1.15rem",
              },
              color: "#0B3C5D",
              fontWeight: 500,
            }}
          >
            School of Life Sciences
          </Typography>
          <Typography
            sx={{
              mt: 2,
              fontSize: {
                xs: "1rem",
                md: "1.2rem",
              },
              fontWeight: 600,
              color: "#0B3C5D",
            }}
          >
            Department of Botany
          </Typography>



          <Typography
            sx={{
              mt: 3,
              maxWidth: 850,
              mx: "auto",
              lineHeight: 1.8,
              color: "#0B3C5D",
              fontSize: {
                xs: "0.95rem",
                md: "1.05rem",
              },
            }}
          >
            Explore the rich botanical diversity of Rayalaseema University
            through a comprehensive digital repository featuring scientifically
            documented plant species, taxonomic classification, ecological
            significance, medicinal uses, conservation status, and high-quality
            photographs.
          </Typography>
          <Paper
  elevation={0}
  sx={{
    mt: 5,
    p: { xs: 3, md: 4 },
    maxWidth: 1000,
    mx: "auto",
    borderRadius: 4,
    background: "rgba(255,255,255,0.85)",
    border: "1px solid #D7EFD9",
    backdropFilter: "blur(8px)",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      mb: 2,
      gap: 1,
    }}
  >
    <VerifiedIcon color="success" />
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        color: "#0B3C5D",
      }}
    >
      Acknowledgement
    </Typography>
  </Box>

  <Typography
  sx={{
    textAlign: "justify",
    lineHeight: 1.9,
    color: "#0B3C5D",
    fontSize: {
      xs: "0.95rem",
      md: "1.05rem",
    },
  }}
>
  The Department of Botany, School of Life Sciences, gratefully acknowledges
  the constant encouragement, guidance, and visionary leadership of the
  Hon'ble Vice Chancellor,{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    Prof. V. Venkata Basava Rao
  </Box>
  , the Rector,{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    Prof. N. T. K. Naik
  </Box>
  , and the Registrar,{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    Prof. B. Vijaya Kumar Naidu
  </Box>
  , Rayalaseema University, for their invaluable support and encouragement in
  the successful development of the Digital Flora.
  <br />
  <br />

  This Digital Flora has been developed by the faculty members{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    Dr. B. Kavitha
  </Box>{" "}
  and{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    Dr. K. Venkata Ratnam
  </Box>
  , with valuable contributions from the students{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    S. Mani Anjali
  </Box>{" "}
  and{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    G. Alekhya
  </Box>{" "}
  of the Department of Botany.
  <br />
  <br />

  Technical design, web development, QR code integration, and digital
  implementation were provided by{" "}
  <Box
    component="span"
    sx={{ color: "#0B3C5D", fontWeight: 700 }}
  >
    Dr. M. Vijay Kumar
  </Box>
  , Department of Computer Science, Rayalaseema University.
</Typography>
</Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default HeroSection;